import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>
              The <span style={{ color: "#2F55C4" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 "
          >
            <p>
              Working with people who share similar values makes the journey
              memorable for everyone. We believed in Maxim’s vision and
              concentrated all our efforts towards the creation of a
              user-friendly and secure business networking app. We made sure
              that the end result was a polished, reliable and easy-to-use
              application that enhances customer satisfaction at every step of
              the way. The SmartID is currently available at the AppStore for
              download.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
